import React, { useState } from "react";
import { FreeSwitchDevelopersFaqs } from "../../../components/faqData.js";
import ContactUs from "../../../components/ContactUs.js";
import { Helmet } from "react-helmet-async";

const pointsData = [
  {
    title: "Replace Physical Presence",
    content:
      "We all lose potential clients when we can't reach the meeting location or primarily when we can't have a physical meeting. Audio-video conferencing solutions act as an escape in such a scenario where you can conduct meetings from any geographic location and be as effective as in person. This means the sky is the limit, and you can quickly grab lucrative opportunities in different locations.",
  },
  {
    title: "Efficient Communication",
    content:
      "With conferencing solutions, communication becomes much more efficient. It allows you to connect with your team or clients at any time without the need to be physically present.",
  },
  {
    title: "Ensure Participants Presence",
    content:
      "Conferencing solutions help ensure that all participants are present and engaged during the meeting by providing tools like attendance tracking, screen sharing, and real-time interaction.",
  },
  {
    title: "Consolidated Communication",
    content:
      "The use of conferencing solutions consolidates all forms of communication, allowing for seamless meetings without worrying about connectivity or location.",
  },
];

const OpenSips = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [actIndex, setActIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActIndex(index === actIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>
          OpenSIPS Development Company India | SIPS Server Solutions -
          Ayanshtech
        </title>
        <meta
          name="description"
          content="Expert OpenSIPS Development Services in India. Build scalable SIP server solutions, VoIP routing, and real-time communication platforms with 24/7 support."
        />

        <meta name="copyright" content="Ayanshtech Solutions" />
        <meta
          property="og:title"
          content="OpenSIPS Development Company India | SIPS Server Solutions - Ayanshtech"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/opensips"
        />
        <meta
          property="og:description"
          content="Expert OpenSIPS Development Services in India. Build scalable SIP server solutions, VoIP routing, and real-time communication platforms with 24/7 support."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@Ayanshtech" />
        <meta
          name="twitter:title"
          content="OpenSIPS Development Company India | SIPS Server Solutions - Ayanshtech"
        />
        <meta
          name="twitter:description"
          content="Expert OpenSIPS Development Services in India. Build scalable SIP server solutions, VoIP routing, and real-time communication platforms with 24/7 support."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link
          rel="canonical"
          href="https://ayanshtechnology.com/opensips"
        ></link>
      </Helmet>
      <div className="flex flex-col items-center justify-center p-6">
        <div className="  w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16  mt-10">
            <div className="lg:w-3/4 text-center lg:text-left p-4">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                OpenSIPS Development Company in India
              </h1>

              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3 ">
                Ayanshtech is a leading OpenSIPS Development Company in India,
                specializing in building high-performance SIP-based
                communication platforms. We deliver scalable, secure, and
                customizable OpenSIPS solutions designed to power modern VoIP,
                video, and messaging systems with maximum efficiency.
              </p>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Our expert developers leverage the flexibility of OpenSIPS to
                create tailored solutions for VoIP service providers, telecom
                operators, and enterprises seeking robust communication
                infrastructure. From SIP routing and load balancing to session
                border controllers (SBCs) and real-time communication systems,
                we help you optimize performance and ensure seamless
                connectivity across your network.
              </p>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                At Ayanshtech, we go beyond standard configurations—offering
                OpenSIPS consulting, integration, and maintenance services that
                align with your business objectives. Whether you’re enhancing
                existing communication systems or developing a new SIP-based
                platform, our team ensures reliability, scalability, and
                cost-effectiveness at every stage. Empower your business with
                next-gen communication solutions built by India’s trusted
                OpenSIPS experts. Partner with Ayanshtech to accelerate
                innovation and achieve superior network performance.
              </p>
              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center  mb-12 lg:mb-0 mt-5">
              <img
                src="\assets\images\headerSection\opensip.png"
                alt="OpenSIPS Development Company in India"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center  p-6 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Features of OpenSIP Software Solution
          </h2>
        </div>

        <div className=" p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon20.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Efficient stateful and stateless SIP proxy processing
              </p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon19.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Support for Presence Agents with XCAP</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon18.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">IP blacklisting for enhanced security</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">
                Robust implementation of RFC3261 for SIP proxy and server
                functionality
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Our Comprehensive OpenSIPS Development Solutions
          </h2>
        </div>

        <div className=" p-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\headerSection\opensip-image.png"
                alt="Laptop with graph"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon16.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Skilled in developing real-time OpenSIPS solutions
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon15.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Proficient in WSS/DTLS-SRTP protocols
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon14.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Expertise in developing OpenSIPS as a SIP proxy
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon13.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Proficient in integrating OpenSIPS for SIP proxy usage
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon12.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    SBC development with RTPEngine for OpenSIPS
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon11.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Capable of building WebRTC-to-SIP gateways using OpenSIPS
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" rounded-3xl mb-8">
          <div className="text-center mb-5 mt-5">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              Our OpenSIPS-Powered Solutions
            </h2>
          </div>

          <div className=" p-6 ">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Item 1 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Class 4 Softswitch</h3>
                <p className="text-lg">
                  Create wholesale switching applications that facilitate
                  seamless call routing and billing for international calls.
                </p>
              </div>

              {/* Item 2 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Contact Center Solutions</h3>
                <p className="text-lg">
                  Build customized contact center applications, eliminating the
                  need for installation costs while providing scalable and
                  efficient solutions.
                </p>
              </div>

              {/* Item 3 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">
                  SBC (Session Border Controller)
                </h3>
                <p className="text-lg">
                  Safeguard your VoIP network from various malicious attacks,
                  such as phishing, vishing, and spoofing, with the
                  implementation of SBC.
                </p>
              </div>

              {/* Item 4 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">IB PBX (IP-based PBX)</h3>
                <p className="text-lg">
                  Host your PBX on the cloud to provide robust VoIP connectivity
                  across the globe, ensuring reliability and performance.
                </p>
              </div>

              {/* Item 5 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">
                  Load Balancing and Failover
                </h3>
                <p className="text-lg">
                  Provide strong alternatives for failover support in case the
                  primary server or database server becomes unavailable,
                  ensuring minimal service disruption.
                </p>
              </div>
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Media Server Integration</h3>
                <p className="text-lg">
                  Enhance media processing capabilities by integrating with
                  media servers for functionalities like call recording,
                  conferencing, and more.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-green-50 p-6 sm:p-8 mb-12 sm:mb-16 rounded-3xl">
          {/* Title Section */}
          <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-6">
            Pain Points & Solutions
          </h2>

          {/* Navigation Bar */}
          <div className="flex justify-center flex-wrap gap-6 sm:gap-8 mb-4">
            {pointsData.map((point, index) => (
              <button
                key={index}
                className={`text-base sm:text-lg font-medium ${
                  activeIndex === index
                    ? "text-blue-600 underline"
                    : "text-gray-900"
                }`}
                onClick={() => setActiveIndex(index)}
              >
                {point.title}
              </button>
            ))}
          </div>

          {/* Content Section */}
          <div className="text-center max-w-5xl mx-auto p-4 border-gray-300">
            <p className="text-base sm:text-lg md:text-xl text-gray-600 mt-4">
              {pointsData[activeIndex].content}
            </p>
          </div>
        </div>

        <div className=" p-6 sm:p-8 md:p-12 lg:p-16 w-full rounded-3xl">
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              OpenSIPS Solutions and Assistance
            </h2>
          </div>
          <div className="mb-8 text-left">
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Ayanshtech offers expert OpenSIPS solutions and ongoing support to
              help you maximize the benefits of your OpenSIPS deployment.
              Whether you’re planning to adopt OpenSIPS or need assistance with
              your current setup, we provide a range of services that ensure you
              get the most out of this powerful platform.
            </p>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Our core offerings include:
            </p>
            <ul className="list-disc pl-8 sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto">
              <li>OpenSIPS setup and configuration</li>
              <li>Tailored solution development</li>
              <li>System diagnostics and support</li>
              <li>Optimization for enhanced performance</li>
              <li>System integrations</li>
              <li>Training and knowledge transfer</li>
            </ul>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              By engaging Ayanshtech for your OpenSIPS consulting and support
              needs, organizations can boost the efficiency, dependability, and
              scalability of their OpenSIPS implementations, while reducing
              operational costs and unlocking the full potential of the
              platform.
            </p>
          </div>
          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="bg-blue-600 hover: hover:text-blue-600 hover:border hover:bg-white hover:border-blue-600 text-white font-semibold py-3 px-6 rounded-full text-lg transition duration-300"
            >
              Book a Free Consultation Now!
            </button>
          </div>
        </div>

        <div className="max-w-3xl mx-auto p-6 py-20 w-full ">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
            FAQs
          </h2>
          {FreeSwitchDevelopersFaqs.map((faq, index) => (
            <div key={index} className="border-b ">
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                  actIndex === index
                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                    : ""
                }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {actIndex === index ? "-" : "+"}
                </span>
              </button>
              {actIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        <div id="contact-section">
          {" "}
          <ContactUs />
        </div>
      </div>
    </>
  );
};

export default OpenSips;
